module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/vegamagic.a2e6a2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/vegamagic.jpg
// module id = VbWF
// module chunks = 0